import React from "react";
import ReactDOM from "react-dom";
import IndexComponent from "./components/index.component";
import "./mi-firma-theme.css";
import "./index.css";
import "./i18n";
import { registerLicense } from '@syncfusion/ej2-base'

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX5dcXVUR2FYVkdzWEc=');

// import DeviceOrientation, { Orientation } from 'react-screen-orientation'
// import { useMediaQuery } from '@material-ui/core'
const FullApp = () => {
  // const isMobileWidth = useMediaQuery('(max-width:600px)')
  // const isMobileHeight = useMediaQuery('(max-height:600px)')
  // if (isMobileWidth || isMobileHeight) return (
  //     <DeviceOrientation lockOrientation={'landscape'}>
  //         <Orientation orientation='landscape' alwaysRender={false}>
  //             <div style={{ height: window.innerHeight + 'px', backgroundColor: '#3b4f0a', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
  //                 <p style={{ color: 'white', fontSize: 'larger' }} >Por favor gire su dispositivo</p>
  //             </div>
  //         </Orientation>
  //         <Orientation orientation='portrait' alwaysRender={false} >
  //             <IndexComponent />
  //         </Orientation>
  //     </DeviceOrientation>
  // )

  return <IndexComponent />;
};
ReactDOM.render(<FullApp />, document.getElementById("root"));
